import _, { find, some, remove } from 'lodash';
import React, { createContext, useEffect, useState } from 'react';
import { getWorkflows, getWorkflowSteps } from '../../../Core/Service/workflow-service';
import { getWorkflowData, saveWorkflowData } from './../../../Core/Service/workflowData-service';
import { getWorkflowListsAndOps } from '../../../Core/Service/workflowList-service';
import { getBranchById } from '../../../Core/Service/branch-screen-service';
import { saveDocumentStamps } from '../../../Core/Service/workflowJobsDocumentStamp-service';
import moment from 'moment';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import { getOcrDocumentHistoryForJob } from '../../../Core/Service/workflowJobDocument-service';

export const ScreenContext = createContext();

export const MarkingType = {
    Stamp: 1,
    Check: 2,
    Cross: 3,
    Calendar: 4,
    Sign: 5,
    Text: 6,
    NA: 7
};

export const FixedImage = {
    Check: 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOpJREFUOE9j/Prr63/uNm4GcsCt7FsMjAwNDP/J0QzTQ7IBmyM2M/iu8IXbSZIBD/IfMMgLyDPMOTOHIXVrKtgQog2AaQZramAE6STegJXBKxnCdMIgGpA0E+eCfwwM/xsh4czdzM3w7d83lDBH8cL/+v8MjI1Qt0GVgcRA4M+/PwyszawYEQY3gOkfE8Pfxr9gBZIdkgwvfr5ggGkGOxXNYKzRiKzhzfc3DCKcIhB/49CMNQyQDYHbQooBIE3EOJ1gSoQZgs/5BKNRmVeZ4e7nu3izCtEpEZcpjI8/PP4vO0GWrAy5M2YnAwDQEVzuLW10/AAAAABJRU5ErkJggg==',
    Cross: 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKFJREFUOE+1U8kNgDAMcxgB8eHHQuzABvxYgg8jMBoLsAJGhRZBFBDl6CdSFLu2lQhJommAtkXUq2ug6yCsKqLvo7DbcFlCCPAZekX9RDBNQJIchVk9U4EbFPH6fKV36aoiti0EgA4nEO/65xloEgN8HeIrglcW9uAg2+r5HM5D1J4dSVSIN9fzg00sCmIYbv6nxvIcspxzlgHjGEeSpgtmBnmGSrnWchiJAAAAAElFTkSuQmCC',
    // NA: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAcNJREFUOE/tlL1rVFEQxc8ZliWxtNt379tgpwhqqWilEhsLlYA2dgEL104LCxU//oOAK9oKgtikEgTRQiRNmggxxSs278576wcoWChLsnfksdmQ9aPaLXO7KeZ3z5wzDDHhxwnzsAsc39FtD9M0uU7amzzvLlfYZtNdNoufQ+i+2qpvmuF7CMWjqvY+aZEIIZSLO2VsA71PemYsp6d/Hc6ybz/StLEEyHIIxdUt4BoZz6+vdz/OzDQOxCirZvZJtfQA+kPoCJBk3QyPVYsrO4He+0MAnqnqwarROfdAxE6Z4YgIz+Z58fqfQICLJOZIO2Nm94cK09TdI2l5rncA0HuXiWDBDLMAyxB0/j9AqXw5GqOdJPmTtLfVyM65VZIXVfWDc+6YCN6TNgvIiRjjtampPY0sy3oVdGRkQFr1ev35xkZvpcoFwENA2mR8kefF/qohTf0CYK3RfbBzw3D+Aqrqk2YzOW3GKt02ya9mJiEUtwHUnHNKWlu1vDv4oLEUo3SKorj0h0I/X6vFd51OuTZYC39BpP+l35cbJG+p6or3fq+IzW1u2suyLMMg/eR4jLJPVZ+OAMdf6QFh9ziM7+TEPfwN4xzRFTcNfGsAAAAASUVORK5CYII=`
    NA: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAShJREFUeNrsVLGKAkEMfZ5go2Bpp72FvYV/oH9gb2GvYONuoaC1gpWdYK9gr39gaWdpp51Wc/cIuczCyHHCXnM+CJkkm7ydvGUz+byLAAyRHuLMF4lDyvjAH+BN8jrJZALsdsBgkMzRfKzXyRx7aLXaExZ+XWr7vftGtWo5mj5Tr0u915O407Ge2cye8+3puhaLcL7bFb/dim82xR+PQKv1C004oNGwAT6YY/18BopFi1croFwO9wRJ+n3x02ky327LYL2FvjlzqkfwNiFNeB6NbNeqyWbj3PUa1lDh13/UZD4HbjeLKxVbjcZcKbUoFMTYoyv0kc3lokgDXvnxkP3Sn05AqSSD7nc5j8fA5SIEjJdLqRPsITn94WAk7x/kPyaJU+aIPwUYAIMN3CpVOzsAAAAAAElFTkSuQmCC`
};

export const WorkflowJobDetailsProvider = (props) => {
    const [widths] = useWindowSize();
    const tabView = widths < 1260 ? true : false;
    const tabSize = widths;

    const [screenState, setScreenState] = useState({
        allFilled: false,
        isReadonly: true,
        showNotesModal: false,
        showHistoryModal: false,
        showReturnReasonModal: false,
        showOcrDocHistory: false,
        documentRotateBy: 0,
        zoomFactor: 1,
        showMailModal: false,
        docInfoToMail: undefined,
        showAllDocModal: false,
        showWarning: false,
        showReturnReasonHistoryModal: false,
        showBarCode: false,
        showCustomerNotes: false
    });

    const [state, setState] = useState({
        tabView: tabView ? true : false,
        jobId: +props.match.params.jobId,
        selectedWorkflowId: +props.match.params.workflowId,
        technicianJobId: props.match.params.technicianJobId || null,
        isTechReadonly: props.match.params.isTechReadonly,
        fromPage: props.match.params.frompage || '',
        selectedOcrDocId: undefined,
        selectedOcrDocName: undefined,
        selectedOcrDocHistoryCount: undefined,
        workflows: [],
        workflowSteps: [],
        workflowStepsList: [],
        imagesFromUrl: [],
        isSelectedFilePdf: false,
        loadingDoc: false,
        currentVisibleDocName: undefined
    });

    const [stampImages, setStampImages] = useState({
        loading: false,
        loaded: false,
        images: []
    });

    const [stampState, setStampState] = useState({
        markingType: null,
        isStart: false,
        isContinue: false,
        needModal: false,
        stamps: []
    });

    const startMarkingMode = () => {
        setStampState((st) => ({ ...st, isStart: true, markingType: null }));
    };

    const stopMarkingMode = () => {
        setStampState((st) => {
            let newSt = { ...st };
            newSt.isStart = false;
            remove(newSt.stamps, (el) => el.isNew);
            newSt.stamps = [...newSt.stamps];
            return newSt;
        });
    };
    const markingTypeSelection = (e, typ) => {
        let other;
        switch (typ) {
            case MarkingType.Stamp:
                if (!stampImages.loading && !stampImages.loaded) {
                    setStampImages((st) => ({ ...st, loading: true }));
                    getBranchById(workflowData?.jobBasicDetail?.branchID).then((res) => {
                        const imgs = res.data.stampImages.map((x) => ({ id: x.branchStampID, src: x.branchStampImage }));
                        setStampImages((st) => ({ ...st, loading: false, loaded: true, images: imgs }));
                    });
                }
                other = { isContinue: false, needModal: true };
                break;
            case MarkingType.Sign:
            case MarkingType.Text:
                other = { isContinue: false, needModal: true };
                break;
            case MarkingType.Check:
            case MarkingType.Cross:
            case MarkingType.NA:
                other = { isContinue: true, needModal: false };
                break;
            case MarkingType.Calendar:
                other = { isContinue: false, needModal: false };
                break;
            default:
                other = { markingType: null, isContinue: false, needModal: false };
                break;
        }
        setStampState((st) => ({ ...st, ...other, markingType: typ }));
    };

    const removeStamp = (stampId) => () => {
        setStampState((st) => {
            let newSt = { ...st };
            remove(newSt.stamps, (el) => el.id === stampId);
            newSt.stamps = [...newSt.stamps];
            return newSt;
        });
    };

    const addNewStamp = (newStamp, heightWidth) => {
        setStampState((st) => {
            let newSt = { ...st };
            newSt.markingType = newSt.isContinue ? newSt.markingType : null;
            newSt.stamps = [...newSt.stamps];
            const last = { ...newStamp, id: moment().valueOf(), isNew: true, info: { ...newStamp.info, ...heightWidth } };
            newSt.stamps.push(last);
            return newSt;
        });
    };

    const setLoadedStamps = (stampData) => {
        setStampState((st) => ({ ...st, stamps: stampData || [], markingType: null }));
    };

    const updateStampInfo = (stampId, info) => {
        setStampState((st) => {
            let newSt = { ...st };
            let stamp = st.stamps.find((s) => s.id === stampId);
            if (stamp) {
                stamp.info = { ...stamp.info, ...info };
            }
            newSt.stamps = [...newSt.stamps];
            return newSt;
        });
    };

    const saveStampData = async () => {
        const stampObj = { allStamps: stampState.stamps.map((c) => _.omit(c, 'isNew')) };
        let res = await saveDocumentStamps(state.jobId, state.selectedOcrDocId, state.selectedOcrDocName, stampObj);
        if (res.success) {
            setLoadedStamps(stampObj.allStamps);
        }
    };

    const [workflowData, setWorkflowData] = useState({
        currentChanges: {},
        fullMergedWorkflowData: {},
        tempMergedData: {},
        workflowDocs: [],
        jobBasicDetail: {},
        hasSomethingToSave: false,
        hasNotes: false
    });

    const updateState = (update) => {
        setState((st) => ({
            ...st,
            ...update
        }));
    };

    const addDocumentImagesData = (ocrDocId, docName, imgBase64Src) => {
        setState((st) => {
            const imagesFromUrl = [...st.imagesFromUrl];
            imagesFromUrl.push(imgBase64Src);
            return {
                ...st,
                selectedOcrDocId: ocrDocId,
                selectedOcrDocName: docName,
                imagesFromUrl
            };
        });
    };

    const dropDownValueSelected = (o) => {
        setWorkflowData((dt) => {
            const newSt = {
                ...dt
            };
            newSt.currentChanges = {
                ...newSt.currentChanges,
                ...o
            };
            newSt.tempMergedData = {
                ...newSt.tempMergedData,
                ...o
            };
            newSt.hasSomethingToSave = !_(newSt.currentChanges)
                .omitBy((a, b) => (newSt.fullMergedWorkflowData[b] || '') === a)
                .isEmpty();
            return newSt;
        });
    };

    const getListOptionById = (id) => {
        const list = state.workflowStepsList.filter((l) => l.id === id);
        return list && list.length === 1 ? list[0].listOptions : [];
    };
    const rotateDoc = (explicit = undefined) => {
        if (explicit === undefined) {
            setScreenState((st) => ({
                ...st,
                documentRotateBy: (st.documentRotateBy + 90) % 360
            }));
        } else {
            setScreenState((st) => ({
                ...st,
                documentRotateBy: explicit
            }));
        }
    };

    const changeZoomFactor = (changeBy) => {
        setScreenState((st) => ({
            ...st,
            zoomFactor: Math.min(2.5, Math.max(0.5, st.zoomFactor + changeBy))
        }));
    };

    const getDocumentFromOcrDocId = (docId) => {
        return find(workflowData.workflowDocs, {
            ocrDocId: docId
        });
    };

    const setDocumentWithOcrDocId = (ocrDocId, docName) => {
        const doc = getDocumentFromOcrDocId(ocrDocId);
        if (doc) {
            doc.docName = docName;
            setWorkflowData((st) => ({
                ...st,
                workflowDocs: [...st.workflowDocs]
            }));
        } else {
            setWorkflowData((st) => ({
                ...st,
                workflowDocs: [
                    ...st.workflowDocs,
                    {
                        ocrDocId,
                        docName
                    }
                ]
            }));
        }
    };

    const showNotes = () => {
        setScreenState((st) => ({
            ...st,
            showNotesModal: true
        }));
    };

    const hideNotesModal = () => {
        setScreenState((st) => ({
            ...st,
            showNotesModal: false
        }));
    };

    const notesAdded = () => {
        setWorkflowData((st) => ({
            ...st,
            hasNotes: true
        }));
    };

    const showHistory = () => {
        setScreenState((st) => ({
            ...st,
            showHistoryModal: true
        }));
    };

    const showReturnReasonHistory = () => {
        setScreenState((st) => ({
            ...st,
            showReturnReasonHistoryModal: true
        }));
    };
    const hideReturnReasonHistory = () => {
        setScreenState((st) => ({
            ...st,
            showReturnReasonHistoryModal: false
        }));
    };
    const hideHistoryModal = () => {
        setScreenState((st) => ({
            ...st,
            showHistoryModal: false
        }));
    };

    const showReturnReason = () => {
        setScreenState((st) => ({
            ...st,
            showReturnReasonModal: true
        }));
    };

    const hideReturnReason = () => {
        setScreenState((st) => ({
            ...st,
            showReturnReasonModal: false
        }));
    };

    const handleCustomerNotes = (val) => {
        setScreenState((st) => ({
            ...st,
            showCustomerNotes: val
        }));
    };

    const showMail = (docInfoToMail) => {
        setScreenState((st) => ({
            ...st,
            showMailModal: true,
            docInfoToMail
        }));
    };

    const hideMail = () => {
        setScreenState((st) => ({
            ...st,
            showMailModal: false,
            docInfoToMail: undefined
        }));
    };

    const showAllDoc = () => {
        setScreenState((st) => ({
            ...st,
            showAllDocModal: true
        }));
    };

    const hideAllDoc = () => {
        setScreenState((st) => ({
            ...st,
            showAllDocModal: false
        }));
    };
    const hideWarningMsg = () => {
        setScreenState((st) => ({
            ...st,
            showWarning: false
        }));
    };

    const returnProcessed = async (hasMsg) => {
        setWorkflowData((st) => ({
            ...st,
            hasNotes: hasMsg,
            showReturnReasonModal: false
        }));
        pullWorkflowSteps();
    };

    const pullWorkflowSteps = () => {
        getWorkflowSteps(state.selectedWorkflowId, state.jobId).then((res) => {
            if (res.success) {
                updateState({
                    workflowSteps: res.data.steps
                });
            }
        });
    };

    const pullWorkflowDataAndSet = async () => {
        getWorkflowData(state.jobId).then((res) => {
            if (res.success) {
                setWorkflowData((st) => ({
                    ...st,
                    currentChanges: {},
                    fullMergedWorkflowData: res.data.workflowData,
                    tempMergedData: {
                        ...res.data.workflowData
                    },
                    workflowDocs: res.data.documents,
                    jobBasicDetail: res.data.jobBasicDetail,
                    hasNotes: res.data.hasNotes,
                    hasSomethingToSave: false
                }));
            }
        });
    };

    const tryToSaveWorkflowData = async (markComplete) => {
        let res = await saveWorkflowData(
            state.jobId,
            {
                done: markComplete,
                workflowData: workflowData.currentChanges,
                workflowId: state.selectedWorkflowId
            },
            state.technicianJobId
        );
        if (res.success) {
            pullWorkflowDataAndSet();
            //setWorkflowData(dt=>({...dt, currentChanges:{}, hasSomethingToSave: false}));
            markComplete && pullWorkflowSteps();
        }
        return res;
    };

    const showOcrDocHistoryModal = () => {
        setScreenState((st) => ({
            ...st,
            showOcrDocHistory: true,
            showAllDocModal: false
        }));
    };

    const hideOcrDocHistoryModal = () => {
        setScreenState((st) => ({
            ...st,
            showOcrDocHistory: false
        }));
        pullWorkflowDataAndSet();
    };
    const onBarCodeClick = () => {
        setScreenState((st) => ({
            ...st,
            showBarCode: true
        }));
    };
    const onBarCodeClose = () => {
        setScreenState((st) => ({
            ...st,
            showBarCode: false
        }));
    };
    const onVehicleStatusClick = () => {
        setScreenState((st) => ({
            ...st,
            siteVehicle: true
        }));
    };

    const handleHistoryModal = (val) => {
        setScreenState((st) => ({ ...st, history: true }));
    };
    const closeHistoryModal = (val) => {
        setScreenState((st) => ({ ...st, history: false }));
    };

    const handleVehicleStatusClose = (res) => {
        let newSt = {};
        newSt.siteVehicle = false;
        if (res) {
            newSt.isReload = new Date();
        }
        setScreenState((st) => ({
            ...st,
            ...newSt
        }));
    };

    const getDocumentHistory = (jobId, ocrDocId) => {
        return getOcrDocumentHistoryForJob(jobId, ocrDocId);
    };

    useEffect(() => {
        if (workflowData.jobBasicDetail.stopFlag) {
            setScreenState((st) => ({
                ...st,
                showWarning: true
            }));
        }
    }, [workflowData.jobBasicDetail.stopFlag]);

    useEffect(() => {
        let fulFormFilled = true;
        state.workflowSteps
            .filter((s) => s.isRequired)
            .forEach((s) => {
                fulFormFilled = fulFormFilled && !!workflowData.tempMergedData[s.jsonPropertyName];
                return fulFormFilled;
            });
        let isReadonlyWorkflow = !some(state.workflowSteps, (s) => s.isEditable);
        setScreenState((st) => ({
            ...st,
            allFilled: fulFormFilled,
            isReadonly: isReadonlyWorkflow
        }));
    }, [workflowData.tempMergedData, state.workflowSteps]);

    useEffect(() => {
        setState((st) => ({
            ...st,
            jobId: +props.match?.params?.jobId,
            selectedWorkflowId: +props.match?.params?.workflowId,
            technicianJobId: props.match?.params?.technicianJobId || null,
            isTechReadonly: props.match?.params?.isTechReadonly,
            fromPage: props.match?.params?.frompage || ''
        }));
    }, [props.match?.params]);

    useEffect(() => {
        pullWorkflowSteps();
        pullWorkflowDataAndSet();
    }, [state.jobId]);
    useEffect(() => {
        getWorkflows().then((res) => {
            if (res.success) {
                const buttons = res.data.map((w) => ({
                    id: w.id,
                    label: w.workflowName,
                    isSelected: w.id === state.selectedWorkflowId
                }));
                updateState({
                    workflows: buttons
                });
            }
        });

        pullWorkflowDataAndSet();
    }, []);

    useEffect(() => {
        if (state.selectedWorkflowId) {
            pullWorkflowSteps();

            getWorkflowListsAndOps(state.selectedWorkflowId).then((res) => {
                if (res.success) {
                    updateState({
                        workflowStepsList: res.data
                    });
                }
            });
        }
    }, [state.selectedWorkflowId]);

    return (
        <ScreenContext.Provider
            value={{
                screenState,
                updateState,
                state,
                stampState,
                stampImages,
                removeStamp,
                addNewStamp,
                startMarkingMode,
                stopMarkingMode,
                markingTypeSelection,
                updateStampInfo,
                setLoadedStamps,
                saveStampData,
                addDocumentImagesData,
                workflowData,
                dropDownValueSelected,
                getListOptionById,
                getDocumentFromOcrDocId,
                setDocumentWithOcrDocId,
                showNotes,
                hideNotesModal,
                notesAdded,
                showHistory,
                hideHistoryModal,
                showReturnReason,
                hideReturnReason,
                returnProcessed,
                tryToSaveWorkflowData,
                showOcrDocHistoryModal,
                hideOcrDocHistoryModal,
                rotateDoc,
                changeZoomFactor,
                showMail,
                hideMail,
                showAllDoc,
                hideAllDoc,
                hideWarningMsg,
                tabView,
                tabSize,
                showReturnReasonHistory,
                hideReturnReasonHistory,
                getDocumentHistory,
                onBarCodeClick,
                onBarCodeClose,
                handleCustomerNotes,
                handleHistoryModal,
                closeHistoryModal,
                handleVehicleStatusClose,
                onVehicleStatusClick
            }}
        >
            {' '}
            {props.children}{' '}
        </ScreenContext.Provider>
    );
};
